<div class="wrapper">
  @for (item of footerUrls; track item) {
    <div class="urls">
      @if (item.layerName) {
      <span class="hoverStyling" [class.selected]="isLayerActive(item.layerName)" (click)="toggleLayer(item.layerName)">
        <span [innerHTML]="item.title"></span>
      </span>
      }
      @else if (item.copy && item.url) {
      <span class="hoverStyling" (click)="copyToClipboard(item.url)">
          <span [innerHTML]="item.title"></span>
          </span>
      }
      @else if (!item.imageUrl && item.url) {
      <span class="hoverStyling" (click)="openUrl(item.url)">
        <span [innerHTML]="item.title"></span>
      </span>
      }
      @else if (item.imageUrl && item.url) {
      <span class="hoverStyling" (click)="openUrl(item.url)">
        <img [src]="item.imageUrl" alt="{{ item.title }}">
      </span>
      }
      @else if (item.html && item.imageUrl) {
      <span class="hoverStyling" (click)="openHtmlInActionView(item)">
        <img [src]="item.imageUrl" alt="{{ item.title }}">
      </span>
      }
      @else if (item.html) {
      <span class="hoverStyling" (click)="openHtmlInActionView(item)">
        <span [innerHTML]="item.title"></span>
      </span>
      }
      @else if (item.imageUrl) {
      <img [src]="item.imageUrl" alt="{{ item.title }}">
      }
      @else {
      <span [innerHTML]="item.title"></span>
      }
    </div>
  }
</div>